var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgAddTaskIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 15.5,
  stroke: "#C5CADA",
  strokeDasharray: "5 5"
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21.5 9h-12C8.673 9 8 9.698 8 10.556v10.888C8 22.302 8.673 23 9.5 23h12c.827 0 1.5-.698 1.5-1.556V10.556C23 9.698 22.327 9 21.5 9Zm-.75 3.111v1.556H17V12.11h3.75ZM17 15.222h3.75v1.556H17v-1.556Zm-7.5 6.222V10.556h5.25v10.888H9.5Z",
  fill: "#C5CADA"
})));
export { SvgAddTaskIcon as ReactComponent };
export default __webpack_public_path__ + "8c45d269dc07ef7fdebb00a01431107b.svg";